"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterProductsByPropertySelections = exports.generatePropertyOptionsFromProducts = exports.PropertyOptions = exports.getPropertyValue = exports.finishesEqual = exports.isSimplePropertyValue = exports.SimplePropertyValue = exports.isDimension = exports.Dimension = exports.DimensionValue = exports.isFinish = void 0;
const S = __importStar(require("effect/Schema"));
/**
 * Configurable Properties
 * These are properties used to support the Visual Inspiration with Variants journey (AKA Conspiration).
 * Product.properties is overloaded and may contain properties which aren't configurable, so we use Product.configurableProperties to call out which
 * properties are configurable.
 *
 * Visual Configuration is based upon particles as opposed to products and handled elsewhere (see gavel and gluon).
 */
const Finish = S.Struct({
    name: S.String,
    colour: S.optional(S.String),
    image: S.optional(S.String),
});
exports.isFinish = S.is(Finish);
exports.DimensionValue = S.Struct({
    value: S.Number,
    label: S.String,
    unit: S.String,
});
exports.Dimension = S.Struct({
    x: exports.DimensionValue,
    y: exports.DimensionValue,
    z: exports.DimensionValue,
});
exports.isDimension = S.is(exports.Dimension);
exports.SimplePropertyValue = S.Union(S.String, S.Number);
exports.isSimplePropertyValue = S.is(exports.SimplePropertyValue);
const finishesEqual = (a, b) => {
    const coloursEqual = a.colour && b.colour ? a.colour === b.colour : true;
    const imagesEqual = a.image && b.image ? a.image === b.image : true;
    return a.name === b.name && coloursEqual && imagesEqual;
};
exports.finishesEqual = finishesEqual;
const getPropertyValue = (key, variant) => {
    const property = variant.properties[key];
    if (property) {
        if ((0, exports.isFinish)(property)) {
            return property.name;
        }
        else if ((0, exports.isDimension)(property)) {
            return `${property.x.value}${property.x.unit} x ${property.y.value}${property.y.unit} x ${property.z.value}${property.z.unit}`;
        }
        else if ((0, exports.isSimplePropertyValue)(property)) {
            return property.toString();
        }
    }
    return undefined;
};
exports.getPropertyValue = getPropertyValue;
/**
 * Property Options and Selections
 * These are used to enable filtering options and product filtering in the Visual Inspiration with Variants journey.
 */
exports.PropertyOptions = S.Record({
    key: S.String,
    value: S.Array(S.String),
});
const generatePropertyOptionsFromProducts = (variants, selections) => {
    return variants.reduce((propertyOptions, variant) => {
        if (variant.kind === 'simple' && variant.configurableProperties) {
            const variantMatchesSelections = Object.entries(selections).every(([selectionKey, selectionValue]) => {
                const propertyValue = (0, exports.getPropertyValue)(selectionKey, variant);
                return propertyValue === selectionValue;
            });
            // only include properties from this variant if all properties on the variant are compatible with the selections
            if (variantMatchesSelections) {
                Object.keys(variant.configurableProperties).forEach(key => {
                    const propertyValue = (0, exports.getPropertyValue)(key, variant);
                    if (propertyValue) {
                        if (propertyOptions[key]) {
                            if (!propertyOptions[key].includes(propertyValue)) {
                                propertyOptions[key].push(propertyValue);
                            }
                        }
                        else {
                            propertyOptions[key] = [propertyValue];
                        }
                    }
                });
            }
        }
        return propertyOptions;
    }, {});
};
exports.generatePropertyOptionsFromProducts = generatePropertyOptionsFromProducts;
const filterProductsByPropertySelections = (products, selections) => {
    return products.filter(product => {
        return Object.entries(selections).every(([selectionKey, selectionValue]) => (0, exports.getPropertyValue)(selectionKey, product) === selectionValue);
    });
};
exports.filterProductsByPropertySelections = filterProductsByPropertySelections;
